import { render, staticRenderFns } from "./contragent-stats.vue?vue&type=template&id=a1e835b0"
import script from "./contragent-stats.vue?vue&type=script&lang=js"
export * from "./contragent-stats.vue?vue&type=script&lang=js"
import style0 from "./contragent-stats.vue?vue&type=style&index=0&id=a1e835b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports